export default "__VITE_ASSET__DADrmlZJ__"